var render = function (_h,_vm) {var _c=_vm._c;return _c('span',{class:[
    _vm.data.staticClass,
    _vm.data.class,
    _vm.$style.label,
    _vm.$kindStyle[_vm.props.kindClass],
    _vm.$sizeStyle[_vm.props.sizeClass] ]},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }